module.exports = __webpack_public_path__ + "img/badge_business_simple.1219629d.png";